/**
 * shared/webauthn-device-limits.ts — device-cap constants + user copy
 *
 * SINGLE SOURCE OF TRUTH for the per-account credential cap (#1604, device-limit
 * spec module 01 §2). Lives in shared/ because BOTH sides render/enforce it:
 * the server enforces the bound (server/logic/webauthn/device-limits.ts) and
 * the client shows the copy (client/src/lib/webauthn-errors/messages.ts) — the
 * cap is owner-steerable 3–5, so a hardcoded client "4" would silently drift.
 */

/**
 * Ceiling on non-revoked WebAuthn credentials per account. Owner-steerable
 * 3–5; rationale for 4: 1 master + 1 daily driver on the other OS + 1 hardware
 * backup + 1 migration/spare slot (spec module 01 §2).
 */
export const MAX_ACTIVE_CREDENTIALS = 4;

/** Cap on the user-chosen device_name label — mirrored by the DB CHECK (0100). */
export const DEVICE_NAME_MAX_LENGTH = 64;

/**
 * Honest cap copy (AC-3): names the limit and points at Security Centre
 * credential removal. Amber-class user error — never red (DESIGN-SYSTEM:
 * red is Forensic Pause / critical OSINT only). Rendered by the server 409
 * body AND the client error map — same string by construction.
 */
export const DEVICE_LIMIT_MESSAGE =
  `You've reached the ${MAX_ACTIVE_CREDENTIALS}-device limit. ` +
  `Remove an unused device in Security Centre to add a new one.`;
